
export default {
    
    // example of how to create your new custom url
    myCustomUrl: "/MyCustomUrl.action" ,
    ipApiUrl : "", // "http://ip-api.com/json",  // requires licensing for commercial use 

    // example of how to overwite an action
    // callcenterUrl: "/CustomCallCenter.action",
}